import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopUpComponent } from '@app/shared/components/pop-up/pop-up.component';

@Injectable({
  providedIn: 'root'
})
export class PopUpService {

  /**
   * Constructor
   * @param dialog 
   */
  constructor(private dialog: MatDialog) { }

  /** open pop up dialog */
  openPopupDialog(header: string, content: string, leftBtn: string, rightBtn: string) {
    const dialogRef = this.dialog.open(PopUpComponent, {
      width: '35%',
      data: { header, content, leftBtn, rightBtn },
      disableClose: true
    });

    return dialogRef.afterClosed();
  }
}
